// src/services/location/LocationContext.tsx
// Context React pour injecter le LocationService

import React, { createContext, useContext, ReactNode } from 'react';
import { LocationService } from './types';
import { BrowserLocationService } from './BrowserLocationService';

// Instance par défaut (navigateur réel)
const defaultService = new BrowserLocationService();

export const LocationContext = createContext<LocationService>(defaultService);

/**
 * Hook pour accéder au LocationService
 * @returns LocationService - le service de location injecté
 */
export const useLocationService = (): LocationService => {
    return useContext(LocationContext);
};

interface LocationProviderProps {
    children: ReactNode;
    service?: LocationService;
}

/**
 * Provider pour injecter un LocationService personnalisé
 * Utile pour les tests avec MockLocationService
 */
export const LocationProvider: React.FC<LocationProviderProps> = ({
    children,
    service = defaultService
}) => {
    return (
        <LocationContext.Provider value={service}>
            {children}
        </LocationContext.Provider>
    );
};

